/*
 * File: JoinEntryStep.styles.js
 * Project: lets-talk-web
 */

/**
 * Imports
 */

import styled from 'styled-components';

/**
 * Styles
 */

export const StepContainer = styled.div`
	width: 100%;
	max-width: 640px;
	margin: 0px auto;
	padding-bottom: 10px;

	.cardPadding {
		padding: 50px;
	}

	h2 {
		text-align: center;
		margin: 10px 0px 10px;
	}

	p {
		text-align: center;
		margin-bottom: 40px;
		color: ${({ theme }) => theme.secondaryText};
	}

	& > p {
		margin-bottom: 40px;
	}

	& > button {
		margin-top: 20px;
	}

	button {
		width: 100%;
	}
`;

export const BottomActionContainer = styled.div`
	margin: 14px 0px 2px;
	text-align: center;
	width: 100%;

	button {
		padding: 0px;
		display: inline-block;
		width: auto;
	}

	p {
		margin: 0px;
		display: inline-block;

		span {
			font-size: inherit !important;
			color: ${({ theme }) => theme.brandPrimaryBase};
		}
	}
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  line-height: 1.2;

  .title {
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 4px;
  }

  .subtitle {
    font-weight: 400;
    font-size: 15px;
    opacity: 0.85;
  }
`;
